import { render, staticRenderFns } from "./RiskScenarioView.vue?vue&type=template&id=155b0850&"
import script from "./RiskScenarioView.vue?vue&type=script&lang=js&"
export * from "./RiskScenarioView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports